module.exports = global.config = {
    Api: {
        url: 'https://test.cloudcontent.dk/api/'
    },GraphQL: {
        url: 'https://test.cloudcontent.dk/graphql/'
    },
    Editor:{

    },
    Profile:{

    },
    History:[]
};